/** Keys produced by presigned upload with `keyPrefix="uploads/hr/leave"`. */
export const HR_LEAVE_ATTACHMENT_KEY_PREFIX = "uploads/hr/leave";

export function validateLeaveAttachmentKey(key: string | null | undefined): void {
  if (key == null || String(key).trim() === "") return;
  const k = String(key).trim();
  if (!k.startsWith(`${HR_LEAVE_ATTACHMENT_KEY_PREFIX}/`)) {
    throw new Error("ເອກະສານຄັດຕິດບໍ່ຖືກຕ້ອງ");
  }
}
